document.addEventListener("DOMContentLoaded", () => {
	const $header = document.querySelector("nova-header");
	const $headerContainer = document.querySelector("#shopify-section-header");
	const $openCart = $header.querySelector(".js-cart-toggle");
const $overlay = document.querySelector(".overlay");
	const $openMenu = $header.querySelector(".js-menu-toggle");
	const $closeMenu = $header.querySelector(".js-menu-close-button");

	$openCart.addEventListener("click", () => {
		document.dispatchEvent(new CustomEvent("nova:cart:open"));
	});

	$openMenu.addEventListener("click", () => {

		$headerContainer.classList.add("menu-open");

		document.dispatchEvent(new CustomEvent("nova:mobile-menu:open"));
	});


	$closeMenu.addEventListener("click", () => {
		handleMenuIconClose();
		document.dispatchEvent(new CustomEvent("nova:mobile-menu:close"));
	});

	document.addEventListener("nova:menu:closed-in-modal", () =>
		handleMenuIconClose(),
	);

	document.addEventListener("nova:cart:focus-last-element", () => { });

	const handleMenuIconClose = () => {
		$headerContainer.classList.remove("menu-open");

	};

	// Check if URL has cart=true parameter
	const urlParams = new URLSearchParams(window.location.search);
	const cartParam = urlParams.get('cart');
	if (cartParam) {
		document.dispatchEvent(new CustomEvent('nova:cart:open'));
	}
})